import { graphql } from "react-relay";

export const AddAPIKeyMutation = graphql`
  mutation AddAPIKeyMutation($input: AddAPIKeyInput!, $connections: [ID!]!) {
    addAPIKey(input: $input) {
      key @appendNode(connections: $connections, edgeTypeName: "APIKeyEdge") {
        description
        expiresAt
        id
        identity
        lastUsed
        revokedAt
      }
      problems {
        message
      }
      secret
    }
  }
`;
